import { useLingui } from '@lingui/react';
import { useCallback } from 'react';

import { activateLocale } from './activate-locale';
import { writeStoredLocale } from './locale-storage';
import { AppLocale, normalizeLocale, SOURCE_LOCALE } from './locales';

/**
 * Текущий язык интерфейса и его смена. Язык применяется сразу, без перезагрузки: `I18nProvider`
 * перерисует дерево. Запоминается только язык, который действительно включился — если каталог
 * не загрузился и `activateLocale` откатился на русский, выбор не сохраняется.
 */
export function useLocale() {
  const { i18n } = useLingui();
  const locale: AppLocale = normalizeLocale(i18n.locale) ?? SOURCE_LOCALE;

  const setLocale = useCallback(async (next: AppLocale) => {
    const active = await activateLocale(next);
    if (active === next) {
      writeStoredLocale(next);
    }
    return active;
  }, []);

  return { locale, setLocale };
}
